exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SafeTechPopup-SafeTechPopup-Popup__editdevice{padding:10px;padding:.625rem;max-width:80%;margin:16px auto;margin:1rem auto;min-height:0}@media (min-width:721px){.SafeTechPopup-SafeTechPopup-Popup__editdevice{width:800px;margin:12rem auto 0}}", ""]);

// exports
exports.locals = {
	"Popup__editdevice": "SafeTechPopup-SafeTechPopup-Popup__editdevice"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/SafeTechPopup/SafeTechPopup.css
// module id = 1088
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20